import { render, staticRenderFns } from "./SelectTaskType.vue?vue&type=template&id=55f8a7bf&"
import script from "./SelectTaskType.vue?vue&type=script&lang=ts&"
export * from "./SelectTaskType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports